import { motion } from "framer-motion";
import { FaHeadphones, FaTools, FaShieldAlt } from "react-icons/fa"; // Importing from react-icons
import Fixed from "./Fixed";
import Footer1 from "./Footer1";

const supportServices = [
  {
    title: "24/7 Customer Assistance",
    description:
      "Our dedicated support team is available round the clock to assist you with queries, troubleshooting, and service-related issues.",
    icon: <FaHeadphones className="text-purple-600 w-16 h-16" />,
  },
  {
    title: "Technical Support & Maintenance",
    description:
      "JCS Global provides expert technical support for IoT solutions, smart automation systems, and software maintenance.",
    icon: <FaTools className="text-teal-600 w-16 h-16" />,
  },
  {
    title: "IoT & Smart Device Support",
    description:
      "We ensure seamless operation of IoT devices, offering remote diagnostics, firmware updates, and system optimizations.",
    icon: <FaShieldAlt className="text-blue-600 w-16 h-16" />,
  },
];

export default function Support() {
  return (
    <div>
      <Fixed />
      <div className="min-h-screen bg-gray-100 text-gray-900 pt-32 px-6">
        {/* Hero Section */}
        <motion.div
          className="text-center max-w-4xl mx-auto mb-12"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-5xl font-bold text-purple-600">JCS Global Support</h1>
          <p className="text-lg text-gray-600 mt-4">
            Reliable customer support and technical assistance for all our services.
          </p>
        </motion.div>

        {/* Support Services Section */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {supportServices.map((service, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 flex flex-col items-center text-center hover:scale-105 transition duration-300"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              {service.icon}
              <h2 className="text-2xl font-semibold text-gray-800 mt-4">{service.title}</h2>
              <p className="text-gray-700 mt-2">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
      <Footer1 />
    </div>
  );
}
